const popupEl = document.querySelector('#popup__goggles');
const popupBttns = document.querySelectorAll('.button__compare-goggles');
const closeBtn = document.querySelector('.popup__close');
popupBttns.forEach(btn => {
  btn.addEventListener('click', () => {
    setTimeout(() => {
      if (!popupEl.classList.contains('show')) {
        popupEl.classList.add('show');
        document.body.classList.add('overflow-h');
      }
    }, 250);
  });
});
closeBtn.addEventListener('click', () => {
  if (popupEl.classList.contains('show')) {
    popupEl.classList.remove('show');
    document.body.classList.remove('overflow-h');
  }
})
document.addEventListener("click", (e) => {
  const isClosest = e.target.closest('.popup__wrap');
  const isCookie = e.target.closest('#onetrust-banner-sdk');
  if (!isCookie && !isClosest && popupEl.classList.contains('show')) {
    popupEl.classList.remove('show');
    document.body.classList.remove('overflow-h');
  }
});
const appHeight = () => {
  const doc = document.documentElement
  doc.style.setProperty('--app-height', `${window.innerHeight}px`)
}
window.addEventListener('resize', appHeight)
appHeight();